import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/data/content";

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="border-b border-[#E4E7EC] bg-[#F9FAFB]"
    >
      <div className="mx-auto max-w-7xl px-5 py-20 md:px-8 md:py-28">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-4">
            <p className="overline mb-4">§ 09 — FAQ</p>
            <h2 className="font-display text-4xl font-black leading-[0.95] tracking-tight text-[#101828] sm:text-5xl md:text-6xl">
              Answers, on the record.
            </h2>
            <p className="mt-6 max-w-md text-base leading-relaxed text-[#475467]">
              Written for search engines and AI answer engines — and for the
              importer or forwarder reading this at 2 AM before a shipment
              lands.
            </p>
          </div>

          <div className="lg:col-span-8">
            <div className="border-2 border-[#101828] bg-white">
              <Accordion type="single" collapsible className="w-full">
                {FAQS.map((f, i) => (
                  <AccordionItem
                    value={`item-${i}`}
                    key={i}
                    className="border-b border-[#E4E7EC] last:border-b-0"
                    data-testid={`faq-item-${i}`}
                  >
                    <AccordionTrigger className="px-6 py-5 text-left font-display text-lg font-bold tracking-tight text-[#101828] hover:no-underline md:text-xl">
                      {f.q}
                    </AccordionTrigger>
                    <AccordionContent className="px-6 pb-6 text-base leading-relaxed text-[#475467]">
                      {f.a}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
